@if (!editing) {
  <section [id]="id" class="not-editing-row">
    <button mat-button (click)="start()" class="flex-justify-centered" [disabled]="disabled">
      {{ quantity }}
      <ng-content></ng-content>
    </button>
  </section>
}
@if (editing) {
  <section [id]="id" class="editing-row" [class.compact]="compact">
    <form [formGroup]="quantityForm" (ngSubmit)="done()">
      <app-form-field-text
        type="number"
        [formGroup]="quantityForm"
        field="quantity"
        [label]="label"
        [mandatory]="mandatory"
        [clearable]="shouldDisplayClearBtn()"
      [errors]="[
        { error: 'max', messageKey: 'commons.validations.short.max' },
        { error: 'min', messageKey: 'commons.validations.short.min' },
        { error: 'required', messageKey: 'commons.validations.short.required' },
      ]"
        [focusAndSelect]="true"
        (enterPressed)="enterPressed($event)"
        (escapePressed)="escapePressed($event)"
        >
      </app-form-field-text>
      <section class="actions">
        @if (!compact) {
          <button id="cancelBtn" mat-button (click)="cancel()">
            {{ 'commons.btn.cancel' | translate }}
          </button>
          <button id="confirmBtn" mat-raised-button color="primary" [disabled]="!quantityForm.valid" type="submit">
            {{ 'commons.btn.done' | translate }}
          </button>
        } @else {
          <button id="confirmIconBtn" mat-icon-button class="icon-btn-mini" color="primary" [disabled]="!quantityForm.valid" (click)="done()">
            <mat-icon>check</mat-icon>
          </button>
          <button id="cancelIconBtn" mat-icon-button class="icon-btn-mini" (click)="cancel()">
            <mat-icon>edit_off</mat-icon>
          </button>
        }
      </section>
    </form>
  </section>
}
